import { HttpError } from 'lib/https';

/**
 * Human-readable message from an API error body, if the server sent one.
 * Backend errors arrive as `{ detail: string }` (FastAPI) or `{ message: string }`;
 * returns undefined when there is nothing better than a generic fallback.
 */
export function getApiErrorDetail(error: unknown): string | undefined {
  if (error instanceof HttpError) {
    const body = error.error as { detail?: unknown; message?: unknown } | undefined;
    if (typeof body?.detail === 'string' && body.detail.trim()) return body.detail;
    if (typeof body?.message === 'string' && body.message.trim()) return body.message;
  }
  if (error instanceof Error && error.message.trim() && !error.message.startsWith('{')) {
    return error.message;
  }
  return undefined;
}
